{
  "version": 1,
  "asset_id": "ea9e5d43-62c4-476b-a275-238fe7a4917f",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/ea9e5d43-62c4-476b-a275-238fe7a4917f/dr-sara-diplomas-b.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/ea9e5d43-62c4-476b-a275-238fe7a4917f/dr-sara-diplomas-b.jpg",
  "original_filename": "dr-sara-diplomas-b.jpg",
  "size": 38968,
  "content_type": "image/jpeg",
  "created_at": "2026-10-27T15:14:37Z"
}
